/** @typedef {import('vuex').Store} Store */

/** @type {Store} */
let store;

/**
 * Register a new store for use anywhere in the application by using getStore().
 * @param {Store} newStore
 */
function registerStore(newStore) {
  store = newStore;
}

/**
 * Returns the registered store or throws an error if no store has been registered.
 * @return {Store}
 * @throws {ReferenceError}
 */
function getStore() {
  if (!store) {
    throw new ReferenceError('No store has been registered.');
  }
  return store;
}

export {
  registerStore,
  getStore,
};
